import dayjs, { Dayjs } from 'dayjs';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const COMPACT_DATE_FORMAT = 'YYYYMMDD';
export const FILE_NAME_DATE_TIME_FORMAT = 'YYYY-MM-DD HH-mm-ss';

export type DateInput = string | number | Date | Dayjs | null | undefined;

// Timestamps come from the API in UTC and are always rendered in the viewer's timezone, so that a
// date shown outside a table matches the dateTimeLocal columns inside it. A missing value means now.
const formatLocal = (value: DateInput, template: string): string => {
  const date = value === null || value === undefined ? dayjs() : dayjs(value);
  return date.isValid() ? date.format(template) : '';
};

export const formatDate = (value?: DateInput): string => formatLocal(value, DATE_FORMAT);

export const formatDateTime = (value?: DateInput): string => formatLocal(value, DATE_TIME_FORMAT);

export const formatCompactDate = (value?: DateInput): string => formatLocal(value, COMPACT_DATE_FORMAT);

export const formatFileNameDateTime = (value?: DateInput): string => formatLocal(value, FILE_NAME_DATE_TIME_FORMAT);
